import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, } from "reactstrap";
import TextField from "../../../common/TextField";
import { toast } from "react-toastify";
import { createCRMLeadCommentService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import { sendSmsService } from "../../../../Services/CRMAdminServices/CRMSmsService";
import { useQueryClient } from "@tanstack/react-query";

interface SendSmsProps {
    toggle: () => void;
    open: boolean;
    mobileNumber: any;
    leadId?: any;
    staffId?: any;
}

const SendSms: React.FC<SendSmsProps> = ({ toggle, open, mobileNumber, leadId, staffId }) => {
    const [message, setMessage] = useState<string>("");
    const queryClient = useQueryClient();

    const handleSendSms = async () => {
        if (!message.trim()) {
            toast.error("Please enter a message.");
            return;
        }
        const formattedNumber = mobileNumber.replace(/\s/g, "");

        try {
            // Through the API. The provider's credentials stay on the server.
            const response: any = await sendSmsService({ mobile: formattedNumber, message });

            if (response) {
                toast.success("Message Sent!");

                // Save comment as well
                if (leadId && staffId) {
                    try {
                        await createCRMLeadCommentService({
                            leadID: leadId,
                            CommentText: `SMS Sent: ${message}`,
                            Staff: staffId,
                            createdBy: "System",
                        });
                        queryClient.invalidateQueries({ queryKey: ["getCRMLeadCommentService"] });
                    } catch (commentError) {
                        console.error("Error saving SMS comment:", commentError);
                        // We don't want to show an error for the comment if the SMS was already sent successfully,
                        // but maybe a warning?
                    }
                }

                setMessage(""); // Clear message
                toggle(); // Close the modal
            } else {
                toast.error("Failed to send SMS. Please try again.");
            }
        } catch (error: any) {
            // The API says why in plain words - a dead number, no credit, not
            // configured - so show that rather than a generic failure.
            toast.error(error?.response?.data?.message || "An error occurred while sending the SMS.");
        }
    };

    return (
        <Modal isOpen={open} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Send SMS</ModalHeader>
            <ModalBody>
                <Label for="smsMessage" className="fw-bold mt-3">
                    Write your message
                </Label>
                <TextField
                    type="textarea"
                    name="message"
                    value={message}
                    setValue={(name, value) => setMessage(value)}
                    rows={5}
                    maxChars={320}
                />
                <div className="mt-2 text-muted">
                    {message.replace(/\s/g, "").length} characters
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSendSms}>
                    Send
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SendSms;
